module.exports = __webpack_public_path__ + "img/slide_2st_bg.24be62c7.svg";